<template>
    <div >
        <table >
         <thead  >
         <tr class="header-row">
            <th  :class="columnTable.label == 'Payment Instruction'? 'Description':'columnhead'"   v-for="columnTable,index in columnData" :key="index">{{columnTable.label }}</th>
         </tr>
         </thead>
         <tbody>
         <tr class="tableData-row"  v-for="tableData,index in columnTableData" :key="index">
          <td  v-for="(colum,index) in columnData " :key="index" :style="colum.style ? colum.style : ''" >
            <slot :value="{'record':tableData, 'column': colum, 'index':index}"></slot>
          </td>
         </tr>
         </tbody>
        </table>
    </div>
</template>
<script>
export default{
    props:{
        columnData:Array,
        columnTableData:Array
    },
    data(){
        return{

        }
    }
}
</script>
<style lang="scss" scoped>
.header-row {
            background-color: white;
            height: 54px;
            th {
                background-color: #f0f1f5;
                border-bottom: 1px solid #34c0be;
                padding: 6px 30px;
            }
        }
        table{
            border-collapse: collapse;
        }
.Description{
    width:68rem;
}
.columnhead{
    width:20rem;
}
.tableData-row:hover{
   &:nth-child(odd){
    background-color: #e1f4f3;
   }
}
.tableData-row{
    background-color: white;
         &:nth-child(even){
            background-color: #f0f4f5;
         }
         td{
            
            padding: 0px 30px;
         }
}
.slno{
    width: 5rem;
    color: #34c0be;
}
</style>